import { Button } from "@/components/ui/button";

export default function ChatbotWidget() {
  const openChatInNewWindow = () => {
    window.open("https://blocbot.zapier.app/", "_blank", "width=800,height=600,scrollbars=yes,resizable=yes");
  };

  return (
    <>
      {/* Floating Buttons Container */}
      <div className="fixed bottom-20 lg:bottom-6 right-4 lg:right-6 z-50 flex flex-col items-center space-y-3 lg:space-y-4">
        {/* WhatsApp Button */}
        <a
          href="https://api.whatsapp.com/send?phone=917995596512&text=Hii"
          target="_blank"
          rel="noopener noreferrer"
          className="w-12 h-12 lg:w-14 lg:h-14 rounded-full bg-green-500 hover:bg-green-600 text-white shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-110 flex items-center justify-center apple-button"
          data-testid="button-whatsapp"
        >
          <i className="fab fa-whatsapp text-xl lg:text-2xl"></i>
        </a>

        {/* Chat Bot Button - Opens directly in new window */}
        <Button
          onClick={openChatInNewWindow}
          className="w-14 h-14 lg:w-16 lg:h-16 rounded-full bg-gradient-to-r from-primary to-primary/80 text-white shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-110 apple-button p-0"
          data-testid="button-open-chat"
        >
          <i className="fas fa-robot text-lg lg:text-xl"></i>
        </Button>
      </div>
    </>
  );
}